import { Alert, Stack, Step, StepContent, StepLabel, Stepper } from "@mui/material";
import score from "./score";
import { useEffect, useMemo, useState } from "react";
import API from "../../../services/API";
import { useParams } from "react-router-dom";
import Loader from "../../Tools/Loader";
import { ArrowRight } from "@mui/icons-material";

export default function Recommendations(){

    const {course} = useParams()

    const [audit, setAudit] = useState([])

    const [status, setStatus] = useState('loading')

    useEffect(() => {

        API.get(`/courses/${course}/audit`)
            .then(r => {
                setAudit(r.data)
                setStatus('ready')
            })
            .catch(_ => setStatus('error'))

    }, [course])

    const rows = useMemo(() => audit
        .filter(row => 
            row.question.recommendation &&
            score(row, 'initial', 'OUI') <= 60
        ),
    [audit])


    if(status === 'loading'){

        return <Loader />
    }


    if(rows.length === 0){

        return <Alert severity="info">Aucune recommandation à afficher.</Alert>
    }

    return (

        <Stack spacing={2}>

            <Alert severity="info">
            L'analyse de vos grilles d'audit nous a permis de mesurer les écarts entre la pratique réelle observée et la pratique attendue ou recommandée. Suite à cette analyse, les points faisant l'objet d'un écart trop important vous sont listés ci-dessous. Vous trouverez ces points, accompagnés d'actions d'amélioration de la qualité des soins. Nous vous recommandons de les mettre en place.
            </Alert>

            <Stepper orientation="vertical">

                {rows.map((row, i) =>

                    <Step key={i} active={true}>

                        <StepLabel icon={<ArrowRight color="info"/>}>
                            {row.question.title}
                        </StepLabel>

                        <StepContent>
                            {row.question.recommendation}
                        </StepContent>
                            
                    </Step>    
                )}
            </Stepper>

        </Stack>

    )
}